import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSelect,
  CSpinner
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import { Input /* , Text */ } from "../SlateComponents";

class HelpdeskModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      creating: false,
      text: [{ type: "paragraph", children: [{ text: "" }] }],
      categories: [{ id: 1, name: "Carregando..." }],
      type: "1",
      id_filho: null
    };
  }

  async componentDidMount() {
    const res = await axios.post(
      `${URL.api}helpdesk/category/list`,
      {},
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({ categories: res.data.data });

    axios
      .get(
        `${URL.api}content/los/listLosChildren/${
          this.props.note.helpdeskObjId || this.props.note.objId
        }`,

        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(resp => {
        this.setState({
          id_filho: resp.data.data[this.props.note.helpdeskAddObjId - 1]?.son_id
        });
      });
  }

  createHelpdesk() {
    this.setState({ creating: true });

    const obj = {
      description: JSON.stringify(this.state.text),
      user_id: this.props.user.user.id,
      category_id: this.state.type,
      status: "ABERTO",
      screenshot: this.props.base64image,
      link: window.location.href,
      type_id: this.props.note.helpdeskTypeId || this.props.note.typeId,
      obj_id: this.props.note.helpdeskObjId || this.props.note.objId,
      additional_obj_id: this.state.id_filho || null
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        /* this.setState({
          text: [{ type: "paragraph", children: [{ text: "" }] }],
          creating: false
        }); */
        this.props.onClose();
      })
      .catch(error => {
        toastr.error("Falha", "Não foi possível criar a solicitação!");
        this.setState({ creating: false });
      });
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        size="lg"
        color="white modal-helpdesk"
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle className="m-0">Iniciar solicitação</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="p-3">
            <CFormGroup>
              <CLabel className="font-weight-bold">Tipo de solicitação</CLabel>
              <CSelect
                value={this.state.type}
                onChange={e => this.setState({ type: e.target.value })}
              >
                {this.state.categories.map((category, index) => (
                  <React.Fragment key={index}>
                    <option value={category.id}>{category.name}</option>
                  </React.Fragment>
                ))}
              </CSelect>
            </CFormGroup>
            <CFormGroup className="font-weight-bold">
              <CLabel>Solicitação</CLabel>
              <Input
                value={this.state.text}
                onChange={value => this.setState({ text: value })}
                placeholder="Digite sua solicitação"
                className2="border-0"
                editable2ClassName="h4 mb-3"
              />
            </CFormGroup>
            <CFormGroup className="font-weight-bold">
              <CLabel>URL</CLabel>
              <CInput
                defaultValue={window.location.href}
                key={`url-${this.props.show}`}
                readOnly
                disabled
              />
            </CFormGroup>
            <CFormGroup className="font-weight-bold">
              <CLabel>Captura de tela</CLabel>
              <div>
                <img
                  src={this.props.base64image}
                  alt=""
                  style={{ height: "120px" }}
                />
              </div>
            </CFormGroup>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            onClick={() => this.createHelpdesk()}
            disabled={this.state.creating}
          >
            <>
              <span style={this.state.creating ? { opacity: 0 } : null}>
                Criar
              </span>
              {this.state.creating && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </>
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpdeskModal);
